export function scroll($, InView) {

	//------------------------------------------------------
	// Scroll Status
	//------------------------------------------------------

	let didScroll;
	let lastScrollTop = 0;
	let delta = 5;
	let minScroll = 1;



	function hasScrolled() {
		let st = $(window).scrollTop();

		// Make sure they scroll more than delta
		if (Math.abs(lastScrollTop - st) <= delta) {
			return;
		}
		if (st > lastScrollTop) {
			// Scroll Down
			$('body')
				.removeClass('scrolled--up scrolled--totop')
				.addClass('scrolled--down');
		} else {
			// Scroll Up
			$('body')
				.removeClass('scrolled--down scrolled--totop')
				.addClass('scrolled--up');
		}

		if (st < minScroll) {
			$('body')
				.removeClass('scrolled--up scrolled--down scrolled')
				.addClass('scrolled--totop');
		}

		lastScrollTop = st;
	}

	//----------------------------------------------------
	// Inview
	//----------------------------------------------------

	let $modules = document.querySelectorAll('.module');

	$modules.forEach(function(el) {
		let inview = InView(el, function(isInView, data) {
		  if (isInView) {
				el.classList.add('inview-on');
		  }
		});
	});

	let $blogmodules = document.querySelectorAll('.blogmodule');

	$blogmodules.forEach(function(el) {
		let inview = InView(el, function(isInView, data) {
		  if (isInView) {
				el.classList.add('inview-on');
		  }
		});
	});

	window.inviewAjax = function() {
		let $blogmodules = document.querySelectorAll('.blogmodule');

		$blogmodules.forEach(function(el) {
			let inview = InView(el, function(isInView, data) {
				if (isInView) {
					el.classList.add('inview-on');
				}
			});
		});
	}

	let $blogcards = document.querySelectorAll('.blogcard');

	$blogcards.forEach(function(el) {
		let inview = InView(el, function(isInView, data) {
		  if (isInView) {
				el.classList.add('inview-on');
		  }
		});
	});

	//----------------------------------------------------
	// ON SCROLL
	//----------------------------------------------------

	$(window).scroll(function () {
		didScroll = true;
		$('body').addClass('scrolled');
	});

	hasScrolled();

	setInterval(function () {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

}
